import { Row } from 'antd';
import styled from 'styled-components';

export const StyledPageWrapper = styled.div``;

export const FullViewHeightContainer = styled.div`
    height: calc(100vh - var(--nav-and-page-header-heigth));
`;

export const StickyContainer = styled.div`
    position: sticky;
    top: 0;
    z-index: 2;
`;

export const SectionWrapper = styled.section`
    width: 100%;
    background-color: var(--gray-1);
    padding: 24px;
    border-radius: 6px;
`;

export const StyledPaperRow = styled(Row)`
    padding: 16px;
    border-radius: 6px;
    background-color: var(--gray-1);
    border: 1px solid var(--gray-4);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    column-gap: 20px;
    row-gap: 5px;
`;

export const iconStyles = {
    error: {
        color: 'var(--dust-red-6)',
        bg: 'var(--dust-red-1)',
    },
    success: {
        color: 'var(--polar-green-6)',
        bg: 'var(--polar-green-1)',
    },
    default: {
        color: 'var(--brand-6)',
        bg: 'var(--brand-1)',
    },
    warning: {
        color: 'var(--orange-6)',
        bg: 'var(--orange-1)',
    },
    note: {
        color: 'var(--cyan-6)',
        bg: 'var(--cyan-1)',
    },
    info: {
        color: 'var(--blue-6)',
        bg: 'var(--blue-1)',
    },
    accent: {
        color: 'var(--purple-6)',
        bg: 'var(--purple-1)',
    },
};

const iconSizeStyles = {
    small: {
        size: '42px',
        borderRadius: '12px',
    },
    medium: {
        size: '64px',
        borderRadius: '24px',
    },
};

export type StyledIconWrapperTypes = 'default' | 'error' | 'success' | 'warning' | 'note' | 'info' | 'accent';

export const StyledIconWrapper = styled.span<{
    $type?: StyledIconWrapperTypes;
    $size?: 'small' | 'medium';
}>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 120px;

    ${({ $size = 'medium' }) => {
        const { size, borderRadius } = iconSizeStyles[$size];
        return `
      width: ${size};
      height: ${size};
      border-radius: ${borderRadius};
    `;
    }}

    ${({ $type = 'default' }) => {
        const { color, bg } = iconStyles[$type];
        return `
      --local-icon-color: ${color};
      --local-icon-bg: ${bg};
    `;
    }}

    color: var(--local-icon-color);
    background-color: var(--local-icon-bg);
`;
